import comp from "./GoogleLoginBtn";
export default comp;
